// Review usage documentation in the README.md file in this directory
declare global {
    interface Window {
        dataLayer: Record<string, unknown>;
    }
}

type incompleteGTMEvent = {
    [key: string]: string | undefined;
} & { event?: never };

type GTMEvent = incompleteGTMEvent & {
    event_action: string;
};

class GoogleTagManager {
    #eventObject: incompleteGTMEvent;

    constructor(event: incompleteGTMEvent) {
        this.#eventObject = event;
    }

    static #sendToDataLayer(event: GTMEvent) {
        if (
            window.dataLayer &&
            Array.isArray(window.dataLayer) &&
            window.dataLayer.length > 0
        ) {
            window.dataLayer.push({ ...event, event: 'web_event' });
        }
    }

    static sendEvent(event: GTMEvent) {
        GoogleTagManager.#sendToDataLayer(event);
    }

    sendEvent(event: GTMEvent) {
        GoogleTagManager.#sendToDataLayer({ ...this.#eventObject, ...event });
    }
}

export { GoogleTagManager };
export type { GTMEvent, incompleteGTMEvent };
